import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import T from 'i18n-react';
import _ from 'lodash';
import { scrollToTop } from 'util/icwUtility';
import Header from '../../Layout/Header/beforeLogin/Header';
import SubscriptionPlan from './SubscriptionPlan';
import SubmitForm from './SubmitForm';
import SelectedPlan from './SelectedPlan';
// const locale = getLocale();

const productList = [
  { label: 'Infrared Thermometer', value: 'thermometer' },
  { label: 'N95 Facial Mask', value: 'n95' },
  { label: 'Surgical Mask', value: 'surgical' },
  { label: 'N/A', value: 'create' },
];

const companyValidationSchema = {
  companyName: Yup.string().required(T.translate('iSource.error.companyName')),
  country: Yup.string().required(T.translate('iSource.error.country')),
  businessType: Yup.array().required(T.translate('iSource.error.businessType')),
  productCategories: Yup.array().required(T.translate('iSource.error.productCategories')),
  countryCode: Yup.string().required(T.translate('iSource.error.countryCode')),
  phone: Yup.string().required(T.translate('iSource.error.phoneNumber')),
  contactPerson: Yup.string().required(T.translate('iSource.error.contactPerson')),
  email: Yup.string()
    .email(T.translate('iSource.error.emailFormat'))
    .required(T.translate('iSource.error.email')),
};

const BuyerForm = ({ onFetchProduct, onSubmit, productCategories, ...otherProps }) => {
  const {
    match: {
      params: { productType },
    },
  } = otherProps;
  const [stepper, setStepper] = React.useState({
    submitForm: true,
    selectPlan: false,
    selectedPlan: false,
  });
  const [agreeTerm, setAgreeTerm] = React.useState(true);
  const [selectedPlan, setSelectedPlan] = useState('freePlan');
  const [selectedProduct, setSelectedProduct] = useState('');

  const formik = useFormik({
    initialValues: {
      companyName: '',
      country: '',
      businessTypes: [],
      countryCode: '',
      phone: '',
      contactPerson: '',
      email: '',
      productCategories: [],
      website: '',
      address: '',
      majorProducts: '',
    },
    validationSchema: Yup.object({
      ...companyValidationSchema,
    }),
  });

  const handleSelectChange = (values, key) => {
    const valArr = values || [];
    formik.setFieldValue(key, valArr, true);
  };

  const handleSelectTouched = (values, key) => {
    formik.setFieldTouched(key, true, true);
  };

  const handleSubmit = () => {
    const { country, ...others } = formik.values;

    const formData = {
      country: country.value,
      ...others,
      selectedPlan,
      selectedProduct: selectedProduct.label,
    };

    onSubmit(formData);

    setStepper({ selectPlan: false, submitForm: false, selectedPlan: true });

    scrollToTop();
  };

  useEffect(() => {
    onFetchProduct();
    setSelectedProduct(productList.find((product) => product.value === productType));

    // eslint-disable-next-line
  }, []);

  return (
    !_.isEmpty(selectedProduct) && (
      <>
        <Header {...otherProps} />
        {stepper.submitForm && (
          <SubmitForm
            {...otherProps}
            formik={formik}
            handleSelectChange={handleSelectChange}
            handleSelectTouched={handleSelectTouched}
            productCategories={productCategories}
            setStepper={setStepper}
            agreeTerm={agreeTerm}
            setAgreeTerm={setAgreeTerm}
          />
        )}
        {stepper.selectPlan && (
          <SubscriptionPlan
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
            stepper={stepper}
            setStepper={setStepper}
            handleSubmit={handleSubmit}
          />
        )}
        {stepper.selectedPlan && (
          <SelectedPlan selectedPlan={selectedPlan} setStepper={setStepper} />
        )}
      </>
    )
  );
};

BuyerForm.propTypes = {
  classes: PropTypes.object,
  history: PropTypes.object,
  productCategories: PropTypes.object,
  onFetchProduct: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default BuyerForm;
